import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  model,
  output,
  signal,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { notify, SiaSelectBoxDataService } from '@sia/shared';
import { SiaAIPromptService } from '../ai-prompt.service';

@Component({
  selector: 'sia-ai-text-button',
  imports: [MatIcon, MatMenu, MatMenuItem, MatMenuTrigger],
  templateUrl: './ai-text-button.component.html',
  styleUrl: './ai-text-button.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaAiTextButtonComponent {
  #siaSelectBoxDataService = inject(SiaSelectBoxDataService);
  #siaAIPromptService = inject(SiaAIPromptService);

  readonly text = model<string>();
  readonly category = input<string>();
  readonly disabled = input<boolean>(false);
  loadPromptList = effect(async () => {
    var data = await this.#siaSelectBoxDataService
      .loadFullData(
        'ai.V_CrudBoxPrompt',
        this.category() ?? '',
        true,
        false,
        true,
      )
      .catch((_err) => {
        notify('Impossibile recuperare i prompt', 2000, 'error');
      });
    this.promptList.set(data ?? []);
  });
  readonly promptLoading = output<boolean>();

  readonly promptList = signal<{ id: number; description: string }[]>([]);
  readonly undoStack = signal<string[]>([]);
  readonly isLoading = signal(false);

  async onPromptClick(prompt: { id: number; description: string }) {
    if (this.disabled()) return;

    this.isLoading.set(true);
    this.promptLoading.emit(true);
    var result = await this.#siaAIPromptService
      .applyPrompt(prompt.id, {
        'user-text': this.text(),
      })
      .catch((err) => {
        notify('Impossibile applicare il prompt', 2000, 'error');
        this.isLoading.set(false);
        this.promptLoading.emit(false);
        return '';
      });
    this.undoStack.update((stack) => [...stack, this.text()!]);

    this.text.set(result);
    this.isLoading.set(false);
    this.promptLoading.emit(false);
  }

  undoClick() {
    if (!this.undoStack().length || this.disabled()) {
      return;
    }
    const lastText = this.undoStack().at(-1)!;
    this.undoStack.update((stack) => stack.slice(0, -1));
    this.text.set(lastText);
  }
}
